

































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component<Footer>({
    props: {
        position: String,
    },
})
export default class Footer extends Vue {}
